import './LoadingScreen.css';

export const LoadingScreen = () => {
    return <div className='loading-background'>
      <div className="loading-container">
      <div className="loading-animation"></div>
    </div> 
  </div>
}